import streamers from '../images/streamers.jpg'

# The church's public Google Calendar.
#
# CALENDAR_EMBED_URL is the `src` out of Google Calendar's "Embed code"
# (calendar settings -> Integrate calendar -> Embed code). It must point at
# https://calendar.google.com/calendar/embed — any other value is ignored so a
# bad edit here can't turn this page into an iframe for arbitrary content.
# While it is empty the page shows the intro and the link, just not the embed.
#
# CALENDAR_LINK opens the calendar on its own full page, for people who want
# more room than the embed gives them.
const CALENDAR_EMBED_URL = "https://calendar.google.com/calendar/embed?src=events%40gracesa.org&ctz=America%2FChicago"
const CALENDAR_LINK = "https://tinyurl.com/grace-lutheran-church-calendar"

css .calendar-page
	min-height:100vh
	d:flex
	fld:column
	.shape-header
		h:300px
	.calendar
		flg: 1
	.calendar-frame
		align-self:center
		w:75%
		w@lt-md:92%
		mb:4em
		rd:md
		overflow:hidden
		shadow: 0px 0px 20px rgba(0,0,0,.25)
		.calendar-embed
			d:block
			w:100%
			# fluid height: tracks the viewport but never shrinks below a
			# usable month grid or grows past a comfortable reading size
			h:clamp(460px, 72vh, 780px)
			border:0
	.calendar-actions
		d:flex
		jc:center
		mb:4em
		.btn
			# .btn is flg:1 globally; keep it to its own width here
			flg:0
			rd:md
			fs:1.15em
			shadow: 0px 0px 10px rgba(0,0,0,.25)

tag calendar-page

	# only embed calendars from the trusted Google Calendar embed endpoint
	get safeEmbed
		let u = String(CALENDAR_EMBED_URL or '')
		u.indexOf('https://calendar.google.com/calendar/embed') == 0 ? u : ''

	<self.calendar-page>
		<shape-header title="Calendar" image=streamers>
		<text-block.calendar title="What's Happening at Grace">
			<p>
				"Worship, learning, music, fellowship and service — here is what is coming up at Grace. Times occasionally change, so do check back before you head downtown."
		if safeEmbed
			<div.calendar-frame>
				<iframe.calendar-embed
					src=safeEmbed
					title="Grace Lutheran Church calendar"
					loading="lazy">
		<div.calendar-actions>
			<a.btn.btn-warning href=CALENDAR_LINK target="_blank" rel="noopener noreferrer">
				"Open full page calendar"

		<footer-section>
